module.exports = __webpack_public_path__ + "img/12d29ab7b6.d29ab7b6.png";